import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { MobileCTABar } from "@/components/layout/MobileCTABar";
import { ChatWidget } from "@/components/ChatWidget";
import { CookieConsent } from "@/components/CookieConsent";
import { PromoPopup } from "@/components/PromoPopup";
import { CatalogPopup } from "@/components/CatalogPopup";
import { PopupScheduler } from "@/components/PopupScheduler";
import { track } from "@/lib/analytics";

export default function PublicLayout({ children }) {
  const loc = useLocation();
  const hidePopups = loc.pathname === "/offerta";
  useEffect(() => {
    window.scrollTo(0, 0);
    track("page_view", { path: loc.pathname });
  }, [loc.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-[var(--sc-canvas)]">
      <Header />
      <main className="flex-1 pb-20 lg:pb-0">{children}</main>
      <Footer />
      <MobileCTABar />
      <ChatWidget />
      <CookieConsent />
      {!hidePopups && <><PromoPopup /><CatalogPopup /><PopupScheduler /></>}
    </div>
  );
}
